import Vue from "vue"
import VueRouter from "vue-router"
import Layout from "@/layout"
import NProgress from "nprogress"
import "nprogress/nprogress.css"

Vue.use(VueRouter)

const whiteList = ["/login"]

const routes = [
  {
    name: "Layout",
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        component: () => import("@/views/home"),
        name: "Home",
        meta: { title: "首页", icon: "home" },
      },
      {
        path: "/price",
        component: () => import("@/views/price"),
        name: "Price",
        meta: { title: "查价", icon: "calculator" },
      },
      {
        name: "Delivery",
        path: "/delivery",
        component: () => import("@/views/delivery"),
        meta: { title: "预报", icon: "truck-moving" },
      },
      {
        name: "Questions",
        path: "/questions",
        component: () => import("@/views/questions"),
        meta: { title: "问题件", icon: "question-circle" },
      },
      {
        name: "Waybill",
        path: "/waybill",
        component: () => import("@/views/waybill"),
        meta: { title: "运单轨迹", icon: "list-alt" },
      },
      {
        name: "Bill",
        path: "/bill",
        component: () => import("@/views/bill"),
        meta: { title: "账单明细", icon: "layer-group" },
      },
      {
        name: "Reconciliation",
        path: "/reconciliation",
        component: () => import("@/views/reconciliation"),
        meta: { title: "运单", icon: "hand-holding-usd" },
      },
      // {
      //   name: "Make",
      //   path: "/make",
      //   component: () => import("@/views/make"),
      //   meta: { title: "制单", icon: "envelope-open-text" },
      // },
      {
        name: "Space",
        path: "/space",
        component: () => import("@/views/space"),
        meta: { title: "通知公告", icon: "users" },
      },
      {
        name: "Quoted",
        path: "/quoted",
        component: () => import("@/views/quoted"),
        meta: { title: "报价目录", icon: "scroll" },
      },
      {
        name: "QuotedDetails",
        path: "/quotedDetails",
        component: () => import("@/views/quoted/details.vue"),
        meta: { title: "报价详情", icon: "scroll", hidden: true },
      },
    ],
  },
  {
    name: "Login",
    path: "/login",
    component: () => import("../views/login"),
    meta: { title: "登录" },
  },
  {
    name: "error",
    path: "*",
    component: () => import("@/views/error/404"),
    meta: { title: "错误" },
  },
]

const router = new VueRouter({
  routes,
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (
    !localStorage.getItem("x-auth-token") &&
    whiteList.indexOf(to.path) == -1
  ) {
    next("/login")
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const originalReplaceh = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplaceh.call(this, location).catch((err) => err)
}

export default router
